import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LegalPersonVerificationMethod, Status, LegalPersonVerificationItem } from '../types/legalPersonVerification';

interface LegalPersonState {
    data: Array<LegalPersonVerificationItem>;
    selectedPage: number;
    totalPage: number;
    selectedIndex: number | null;
}

const initialState: LegalPersonState = {
    data: [
        // {
        //     name: 'A15BC Inc.',
        //     corporate_number: 1000000000000,
        //     received_date: '2024-10-07',
        //     reference_person_department: 'General Affairs Department',
        //     reference_person_name: 'Sato Jiro',
        //     legal_person_verificaiton_method: LegalPersonVerificationMethod.corporate_number_verification,
        //     status: Status.inprogress,
        //     verification_type: VerificationType.document_verification,
        //     proceed_user: 'Taro Yamada',
        //     completed_email: 'yamada@example.com'
        // },
        // {
        //     name: 'B16CD Inc.',
        //     corporate_number: 1000000000001,
        //     received_date: '2024-10-07',
        //     reference_person_department: 'Accounting Department',
        //     reference_person_name: 'Takahashi Shiro',
        //     legal_person_verificaiton_method: LegalPersonVerificationMethod.legal_person_verification,
        //     status: Status.failed,
        //     verification_type: VerificationType.db_verification,
        //     proceed_user: 'Taro Yamada',
        //     completed_email: 'yamada@example.com'
        // },
        // {
        //     name: 'C17DE Inc.',
        //     corporate_number: 1000000000002,
        //     received_date: '2024-10-07',
        //     reference_person_department: 'General Affairs Department',
        //     reference_person_name: 'Sato Jiro',
        //     legal_person_verificaiton_method: LegalPersonVerificationMethod.corporate_number_verification,
        //     status: Status.completed,
        //     verification_type: VerificationType.legal_person_verification,
        //     proceed_user: 'Taro Yamada',
        //     completed_email: 'yamada@example.com'
        // },
        // {
        //     name: 'D18EF Inc.',
        //     corporate_number: 1000000000003,
        //     received_date: '2024-10-07',
        //     reference_person_department: 'Accounting Department',
        //     reference_person_name: 'Takahashi Shiro',
        //     legal_person_verificaiton_method: LegalPersonVerificationMethod.corporate_number_verification,
        //     status: Status.inprogress,
        //     verification_type: VerificationType.personal_verification,
        //     proceed_user: 'Taro Yamada',
        //     completed_email: 'yamada@example.com'
        // },
        // {
        //     name: 'E19FG Inc.',
        //     corporate_number: 1000000000004,
        //     received_date: '2024-10-07',
        //     reference_person_department: 'General Affairs Department',
        //     reference_person_name: 'Sato Jiro',
        //     legal_person_verificaiton_method: LegalPersonVerificationMethod.corporate_number_verification,
        //     status: Status.failed,
        //     verification_type: VerificationType.document_verification,
        //     proceed_user: 'Taro Yamada',
        //     completed_email: 'yamada@example.com'
        // },
        // {
        //     name: 'F20GH Inc.',
        //     corporate_number: 1000000000005,
        //     received_date: '2024-10-07',
        //     reference_person_department: 'Accounting Department',
        //     reference_person_name: 'Takahashi Shiro',
        //     legal_person_verificaiton_method: LegalPersonVerificationMethod.corporate_number_verification,
        //     status: Status.completed,
        //     verification_type: VerificationType.document_verification,
        //     proceed_user: 'Taro Yamada',
        //     completed_email: 'yamada@example.com'
        // },
    ],
    selectedPage: 1,
    totalPage: 8,
    selectedIndex: null
};

const legalPersonSlice = createSlice({
    name: 'legalPerson',
    initialState,
    reducers: {
        setSelectedIndex: (state, action: PayloadAction<number | null>) => {
            state.selectedIndex = action.payload;
        },
        handlePrevPage: (state) => {
            state.selectedPage = state.selectedPage - 1 < 1 ? 1 : state.selectedPage - 1;
        },
        handleNextPage: (state) => {
            state.selectedPage = state.selectedPage + 1 > state.totalPage ? state.totalPage : state.selectedPage + 1;
        }
    },
});

export const { setSelectedIndex, handlePrevPage, handleNextPage } = legalPersonSlice.actions;

export default legalPersonSlice.reducer;